export enum Product {
    AITL = 'AITrustLayer',
}

interface FederatedPolicyProduct {
    name: string;
    label: string;
    isRestricted: boolean;
    isCloud: boolean;
    isRemote: boolean;
}

interface FederatedPolicyTenant {
    tenantIdentifier: string;
    policyIdentifier: string;
    productIdentifier: string;
    licenseTypeIdentifier: string;
    tenantName: string;
}

interface FederatedPolicyUser {
    userId: string;
    userName: string;
    policyIdentifier: string;
    productIdentifier: string;
}

interface FederatedPolicyGroup {
    groupId: string;
    groupName: string;
    policyIdentifier: string;
    productIdentifier: string;
}

export interface FederatedPolicy {
    name: string;
    identifier: string;
    product: FederatedPolicyProduct;
    description: string | null;
    priority: number;
    availability: number;
    tenantPolicies: FederatedPolicyTenant[];
    userPolicies: FederatedPolicyUser[];
    groupPolicies: FederatedPolicyGroup[];
}

export interface FederatedPolicyPagedResult {
    totalCount: number;
    result: FederatedPolicy[];
}

export interface TenantPolicyEntry {
    tenantIdentifier: string;
    policyIdentifier: string | null;
    productIdentifier: string;
    licenseTypeIdentifier: string;
    tenantName?: string;
}

export interface TenantPolicyResponse {
    name: string;
    identifier: string;
    url: string;
    status: string;
    tenantPolicies: TenantPolicyEntry[];
}
